import routes from './appModals.routes';

export const appModalsModule = {
    routes
};